var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivebetsGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "insertchart_00000167370004779907607860000013826428232957040033_",
    gradientUnits: "userSpaceOnUse",
    x1: -506.0278,
    y1: 544.5278,
    x2: -506.0278,
    y2: 543.5278,
    gradientTransform: "matrix(36 0 0 -36 18235.0156 19603.0176)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9E021"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009245"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "insertchart",
    style: {
      fill: "url(#insertchart_00000167370004779907607860000013826428232957040033_)"
    },
    d: "M8.2,28.2h3V14.4 h-3L8.2,28.2z M16.5,28.2h3V7.9h-3V28.2z M24.8,28.2h3v-7.4h-3V28.2z M3,36c-0.8,0-1.6-0.3-2.1-0.9C0.3,34.6,0,33.8,0,33V3 c0-0.8,0.3-1.6,0.9-2.1C1.4,0.3,2.2,0,3,0h30c0.8,0,1.6,0.3,2.1,0.9C35.7,1.4,36,2.2,36,3v30c0,1.6-1.4,3-3,3H3z M3,33h30V3H3V33z  M3,3L3,3z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivebetsGreen);
export default __webpack_public_path__ + "static/media/activebets_green.4905c151dfbec362e15c067b588d4dba.svg";
export { ForwardRef as ReactComponent };